export default __webpack_public_path__ + "static/media/bidcaching.89d4e813.svg";